export default __webpack_public_path__ + "static/universltpro-bold-5af1a9ad0fd38a46f94b226737221c02.woff";